var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "user-tooltip",
      attrs: { target: "_blank" },
      on: {
        click: function ($event) {
          return _vm.openHelpPopUp("data.html")
        },
      },
    },
    [
      _c("img", {
        attrs: {
          src: _vm.userCommonImageUrlForSp + "/tooltip_help_sp.png",
          alt: "データの説明",
          width: "25",
          height: "25",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }